import { actions, selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { useMemo } from 'react';
import { $a } from 'shared-base';
import { StyleTransferPreview } from './StyleTransferPreview';

export type StyleTransferPreviewContainerProps = {};

export function StyleTransferPreviewContainer(_props: StyleTransferPreviewContainerProps) {
  const dispatch = useDispatch();
  const realtimeState = useSelector(selectors.raw.$rawRealtimeState);
  const { isStyleTransferDialogOpen, styleTransferStyle, styleTransferImageId } = realtimeState;

  const callbacks = useMemo(
    () => ({
      onClose: () => {
        dispatch(actions.realtimeState.patch({ isStyleTransferDialogOpen: false }));
      },
      onApply: () => {
        dispatch(actions.realtimeState.patch({ isStyleTransferDialogOpen: false }));
        dispatch($a('SCENE', 'applySceneBackground'));
      },
    }),
    []
  );

  if (!isStyleTransferDialogOpen) {
    return null;
  }

  return (
    <StyleTransferPreview
      styleTransferImageId={styleTransferImageId}
      styleTransferStyle={styleTransferStyle}
      onClose={callbacks.onClose}
      onApply={callbacks.onApply}
    />
  );
}

export default StyleTransferPreviewContainer;
